import { Component, effect, input, output } from '@angular/core'
import { AbstractControl, FormGroup, ReactiveFormsModule } from '@angular/forms'
import { BndButton, BndModal, BndTextarea } from '@bonduelle-it/storybook'
import { TranslatePipe } from '@ngx-translate/core'

export interface AoNoteDialogData {
  noteFormControl: AbstractControl | null | undefined
}

@Component({
  selector: 'ao-note-dialog',
  templateUrl: './ao-note-dialog.component.html',
  imports: [BndButton, BndTextarea, ReactiveFormsModule, TranslatePipe, BndModal],
})
export class AoNoteDialogComponent {
  public readonly open = input(false)
  public readonly data = input<AoNoteDialogData>()
  public result = output<string | null | undefined>()

  private _initialNoteValue: string | null = null

  form: FormGroup = new FormGroup({})

  constructor() {
    effect(() => {
      if (this.open()) {
        const control = this.data()?.noteFormControl
        this.form = new FormGroup({})
        if (control) {
          this.form.addControl('note', control)
        }
        this._initialNoteValue = control?.value
      }
    })
  }

  // Backdrop/ESC close leaves the shared control untouched, matching the original dialog behavior.
  onDismiss() {
    this.result.emit(undefined)
  }

  onCancel() {
    this.result.emit(this._initialNoteValue)
  }

  save() {
    this.result.emit(this.form.get('note')?.value)
  }
}
